
import { z } from "zod";
import { CreateUserRequest } from "@/api/generated/client/models";

// 1. Define Validations (The Schema)
export const signupSchema = z.object({
    firstName: z.string().trim().min(1, "First name is required"),
    lastName: z.string().trim().min(1, "Last name is required"),
    email: z.string().email("Please enter a valid email address"),
    password: z.string().min(6, "Password must be at least 6 characters"),
    confirmPassword: z.string()
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
});

// 2. Infer Types
export type SignupForm = z.infer<typeof signupSchema>;

// 3. DRIFT PROTECTION
// Ensure our form stays compatible with Backend Types
// This is exported just so it's compiled, but it's a compile-time check only.
export type _BackendCheck = Pick<SignupForm, "email"> extends Pick<CreateUserRequest, "email"> ? true : false;

export const loginSchema = z.object({
    password: z.string().min(1, "Password is required"),
    email: z.string().email("Please enter a valid email address"),
});

export type LoginForm = z.infer<typeof loginSchema>;
